module.exports = __webpack_public_path__ + "img/rosa_sudeck_7.373166d9.jpg";